import { render, staticRenderFns } from "./LamboCustomerTreatmentColumn.vue?vue&type=template&id=2ec83d9c&"
import script from "./LamboCustomerTreatmentColumn.vue?vue&type=script&lang=js&"
export * from "./LamboCustomerTreatmentColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports